import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { handleHttpError } from './handle-http-error.service';
import { catchError, Observable, retry } from 'rxjs';
import { APICallingLimit } from './constant.service';
import {  EndFinBoxSession_V1Req, EndFinboxSessionReq, FinBoxStatusReq, GetFinboxBankSDKURLReq, GetFinboxURLReq, GetVendorURLReq, PushSegment2Req, PushSegmentReq, UploadManuallyReq, VendorStatusReq } from '../models/request.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }

  getGeoLocation(): Observable<any> {
    const params = new HttpParams().set('apiKey', environment.ipgeo_Key);
    return this.http.get<any>(environment.geoLocationUrl, { params }).pipe(
      retry(APICallingLimit.one_1), // Simple retry logic with a fixed number of retries
      catchError(handleHttpError)
    );
  }

  PushSegment(
    pushSegmentReq: PushSegmentReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'PushSegment',
        pushSegmentReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  GetFinboxBankSDKURL(
    getFinboxBankSDKURLReq: GetFinboxBankSDKURLReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'GetFinboxBankSDKURL',
        getFinboxBankSDKURLReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  getFinboxURL(
    getFinboxURLReq: GetFinboxURLReq
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/get-finbox-url',
        getFinboxURLReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  EndFinBoxSession_V1(
    endFinBoxSession_V1Req: EndFinBoxSession_V1Req
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'EndFinBoxSession_V1',
        endFinBoxSession_V1Req,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  endFinboxSession(
    endFinboxSessionReq: EndFinboxSessionReq
  ): Observable<any> {
    
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/end-finbox-session',
        endFinboxSessionReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }
 
  FinBoxStatus(
    finBoxStatusReq: FinBoxStatusReq
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': environment.gateWayModificationKey,
    });
    return this.http
      .post<any>(
        environment.baseModificationAPI + 'FinBoxStatus',
        finBoxStatusReq,
        { headers }
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  FinBoxStatus2(
    finBoxStatusReq: FinBoxStatusReq
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/vendor-status',
        finBoxStatusReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  PushSegment2(
    pushSegment2Req: PushSegment2Req
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/push-segment',
        pushSegment2Req,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  uploadManually2(
   uploadManuallyReq: UploadManuallyReq
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/manual-upload',
        uploadManuallyReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }

  getVendorStatus(
   VendorStatusReq: VendorStatusReq
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/vendor-status',
        VendorStatusReq,
      )
      .pipe(retry(APICallingLimit.zero_0), catchError(handleHttpError));
  }

  getVendorURL(
   GetVendorURLReq: GetVendorURLReq
  ): Observable<any> {
    return this.http
      .post<any>(
        environment.kyc_Url + 'modification/segment/get-vendor-url',
        GetVendorURLReq,
      )
      .pipe(retry(APICallingLimit.one_1), catchError(handleHttpError));
  }
}
